// Module
var code = "<div v-if=\"field != null && field != ''\" class=\"mb-3 flex items-start\"> <p class=\"text-gray-700 inline-block w-32\">{{ label }}</p> <div class=\"flex-1\"> <slot>{{ field }}</slot> </div> </div> ";
// Exports
export default code;